import Vue from 'vue'
export const tooltipBus = new Vue()